module.exports = __webpack_public_path__ + "static/media/my_bag.4111173a.svg";